<template>
    <div style="height: 100%; width: 100%">
        <v-row>
            <v-col class="py-0">
                <v-card
                    height="340px" 
                    class="py-5 align-start"
                    color='white'> <!--height="350" height="100%"-->
                    <p class="ml-3 font-weight-bold"
                    >Comments</p>
                    <v-divider></v-divider>
                    <v-card-text class="pb-4">
                        <div align="center">
                            <v-row class="mt-n3">
                                <v-col class="text-left" cols="10">
                                    <v-textarea
                                        id="comment"
                                        v-model="comment.content"
                                        outlined
                                        rows="1"
                                        label="Write your comments..."
                                    ></v-textarea>
                                </v-col>
                                <v-col class="text-left ml-n2 my-2" cols="2">
                                    <v-btn
                                        small
                                        fab
                                        depressed
                                        color="accent"
                                        style="font-size:14px"
                                        @click="addComment"
                                        ><v-icon>mdi-plus</v-icon></v-btn>
                                </v-col>
                            </v-row>
                        </div>
                        <transition name="shake">
                            <p class="red--text shake text-left mt-n9 ml-1" 
                                v-if="error"
                                >{{error}}
                            </p> <!-- Añadida por Mariana-->
                        </transition>
                        <div class="mt-n4" align="left">
                            <v-card flat height="160" class="scroll">
                                <v-row 
                                    class="mt-n5 mx-n4 mb-n10" 
                                    v-for="(comment, index) in comments" 
                                    :key="index"
                                >
                                    <v-col cols="5" >
                                        <v-card-text 
                                            class="text-left font-italic mx-n2"
                                            >{{comment.date}}
                                        </v-card-text>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-card-text 
                                            class=" black--text text-left mx-n15"
                                            >{{comment.content}}
                                        </v-card-text>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-btn
                                            fab
                                            text
                                            x-small 
                                            depressed 
                                            color="danger" 
                                            class="white--text mt-2 mx-n10" 
                                            @click="deleteWindow(meter.name, comment.creationDate)">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-dialog v-model="deletePopUp" persistent width="370" class="align-center">
                                <template>
                                    <v-card height="160">
                                    <v-toolbar :elevation="0" color="primary" dark>
                                        <v-toolbar-title>Delete comment</v-toolbar-title>
                                    </v-toolbar>
                                        <v-form ref="form" class="text-center mt-3">
                                            Do you want to delete this comment?
                                        </v-form>
                                        <div align="right" class="align-content-end mx-4 mt-3">
                                            <v-btn color="danger" 
                                                small
                                                class="white--text mx-2"
                                                @click="delComm(meter.name, d_comment.creationDate)"
                                                >Delete
                                            </v-btn>
                                            <v-btn color="danger" 
                                                small 
                                                text
                                                @click="closeDelete"
                                                >Cancel
                                            </v-btn>
                                        </div>
                                    </v-card>
                                </template>
                            </v-dialog>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
// import { db } from '../../plugins/firebase'
export default {
    name: 'comments',
    props: ['meter'],
    computed: {
        ...mapState({comments: state => state.meters.comments}),
    },
    data() {
        return {
            openPopUp: false,
            comment: {
                content: '',
                date: '',
                creationDate: ''
            },
            error: '',
            deletePopUp: false,
            d_comment: {
                content: '',
                date: '',
                creationDate: ''
            },
        }
    },
    methods: {
        ...mapActions({
            newComment: 'meters/newComment',
            getComments: 'meters/getComments',
            deleteComment: 'meters/deleteComment'
        }),
        open(){
            this.openPopUp = true
        },
        async addComment(){
            let name = this.meter.name
            let t = new Date()
            let today = moment(t).format('L')
            this.comment.creationDate = t
            this.comment.date = today
            if (!(this.comment.hasOwnProperty('content')) || this.comment.content === '') {
                this.error = 'Empty field, fill it please'
                return
            }else{
                this.error = ''
                await this.newComment({
                    name: name,
                    content: this.comment.content, 
                    date: this.comment.date,
                    creationDate: this.comment.creationDate
                })
                this.refresh()
                this.comment = {}
            }
        },
        deleteWindow(name, creationDate){
            // console.log(name, creationDate)
            this.d_comment.creationDate = creationDate
            this.deletePopUp = true
            // await this.deleteComment({name, content})
            // this.refresh()
        },
        close(){
            this.openPopUp = false
            this.$emit('close')
        },
        closeDelete(){
            this.deletePopUp = false
        },
        async delComm(name, creationDate){
            // console.log(name, creationDate)
            await this.deleteComment({name, creationDate})
            // this.refresh()
            this.d_comment.comment = ''
            this.deletePopUp = false
            return
        },
        async refresh(){
            // await this.$store.dispatch('meters/setCollectionDb')
            await this.getComments(this.meter.name)
        }
    },
    async mounted() {
        this.refresh()
    }
}
</script>

<style>
.scroll {
   overflow-y: auto;
   overflow-x: hidden;
   margin-top: auto;
}
</style>